module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/navigate/navigate.component.less
// module id = ./src/app/component/navigate/navigate.component.less
// module chunks = main